const initialState = {
  sidebarShow: false,
  sidebarUnfoldable: false,
}

const menuOptions = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'SET_MENU_OPTIONS':  return { ...state, ...rest }
    default:
      return state
  }
}

export default menuOptions
